var map = {
	"./icon-excel.png": "d410",
	"./icon-image.png": "ca95",
	"./icon-link.png": "e0c5",
	"./icon-music.png": "695b",
	"./icon-other.png": "c064",
	"./icon-pdf.png": "bc1f",
	"./icon-ppt.png": "8c07",
	"./icon-txt.png": "b1e7",
	"./icon-video.png": "1640",
	"./icon-word.png": "d04d",
	"./icon-zip.png": "42be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "266e";